import React from "react";

import { useStyles } from "./styles";

interface IDividerProps {
    left?: number;
    right?: number;
}

export const Divider = ({ left, right }: IDividerProps) => {
    const classes = useStyles();
    return <div className={classes.wrapper} style={{ left, right }} />;
};
